import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { Title1 } from '@ui/Typography'
import { Button } from '@ui/components/Button'

import { CommonPaths } from '@utils/path'

import { useLandingPage } from '@hooks/useLandingPage'

import { NotificationsNotFoundGraphic } from '@assets/graphics/NotificationsNotFound.graphic'

import { Box } from '@shared/components/Box'

import styles from './NotificationCenter.module.scss'

export const NotificationsNotFound = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const { getLandingPage } = useLandingPage()

  const handleGoBack = () => {
    const path = getLandingPage() || CommonPaths.TradersRoomWallets
    navigate(path)
  }

  return (
    <div className={styles.notificationsNotFound}>
      <NotificationsNotFoundGraphic />
      <Title1 className={styles.notificationsNotFoundTitle} medium>
        {t('Notifications.You have no new notifications')}
      </Title1>
      <Box className={styles.goBackButton}>
        <Button.Primary size='md' fullWidth onClick={handleGoBack}>
          {t('Go back')}
        </Button.Primary>
      </Box>
    </div>
  )
}
